/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */

import { FC } from "react";

type Props = {
  className?: string;
  width?: string;
  height?: string;
  fill?: string;
};

const InfoIcon: FC<Props> = ({
  className = "",
  width = "28",
  height = "28",
  fill = "white",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      test-id="HgaIX9tc"
      className={className}
    >
      <path
        d="M12.8726 17.5996L11.1274 17.5996L11.1274 11.1996L12.8726 11.1996L12.8726 17.5996Z"
        fill={fill}
        test-id="GvLoIy1D"
      />

      <path
        d="M12.7997 9.59961L11.1997 9.59961L10.7874 7.19961L13.1992 7.19961L12.7997 9.59961Z"
        fill={fill}
        test-id="NpG_rHyp"
      />

      <circle
        cx="12"
        cy="12"
        r="8.75"
        stroke={fill}
        strokeWidth="1.5"
        test-id="qHC3SKo3"
      />
    </svg>
  );
};

export default InfoIcon;
